import { Tooltip, ITooltipProps } from "@gisce/oficina-virtual-components";
import { styled } from "@mui/material";

interface CustomTooltipProps extends ITooltipProps {
  maxWidth?: number;
  className?: string;
}

export const CustomTooltip = styled(
  ({ className, maxWidth, ...props }: CustomTooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  )
)<{ maxWidth?: number }>(({ maxWidth }) => ({
  [`& .MuiTooltip-tooltip`]: {
    backgroundColor: 'white',
    color: "black",
    maxWidth: maxWidth ?? 400,
    border: '2px solid grey',
    fontSize: "12pt",
    padding: "16px",
    fontWeight: "400",
  },
}));